import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import HeaderImage from "../../assets/images/pre-contract-summary-img.PNG";

const styles = StyleSheet.create({
  pdfHeader: {
    width: "100%",
    height: 65,
  },

  imageStyle: {
    width: "100%",
  },
});

// Main PDF Document
const ContractSummaryHeader = ({ children }) => (
  <View>
    <View style={styles.pdfHeader} fixed>
      <Image src={HeaderImage} style={styles.imageStyle} />
    </View>
    <View>{children}</View>
  </View>
);

export default ContractSummaryHeader;
